import type { ComponentPropsWithoutRef } from "react";
import classNames from "classnames";

export interface BlockProps extends ComponentPropsWithoutRef<"div"> {}

export const Block = ({ className, ...rest }: BlockProps) => (
  <div className={classNames("bg-tertiary", className)} {...rest} />
);
